import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DebugConfigComponent } from './debug-config/debug-config.component';
import { DebugVoiceComponent } from './debug-voice/debug-voice.component';
import { DebugFaceComponent } from './debug-face/debug-face.component';
import { DebugBrowserComponent } from './debug-browser/debug-browser.component';

const routes: Routes = [
  { path: '', component: DebugConfigComponent },
  { path: 'voice', component: DebugVoiceComponent },
  { path: 'face', component: DebugFaceComponent },
  { path: 'browser', component: DebugBrowserComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DebugRoutingModule { }
